<template>
    <div>
	    <div v-if="selectChoicesLoaded && socialNetworksLoaded">
		    <div v-for="(question, index) in myQuestions">
		        <question-list-entry :question="question" 
                    v-on:updateValue="updateAnswer" 
                    :index="index" 
                    :socialnetworks="socialNetworks" 
                    :crew="crew"
                    ref="questionEntry">
                </question-list-entry>
		    </div>
		</div>
	</div>
</template>

<script>
    import helper from '../js/article-helper.js'
    import {Radio, QuestionElement, Select, Check} from '../js/questionnaire-helper.js'
    import QuestionListEntry from './QuestionListEntry.vue'
    
	export default {
		name: 'question-list',
		props: {
            questions: Array,
            crew: {
	    		type: String,
		    	required: false,
			    default: ''
			}
        },

        data: function() {
        	return {
        		selectChoicesLoaded: false,
        		socialNetworksLoaded: false,
        		frage: {},
        		socialNetworks: [],
                myQuestions: []
        	}
        },
        created: function() {
        	this.getSelectChoices(this.getSelectChoicesSuccess);
        	this.getSocialNetworks();
            //Addresse nur für Crew Registrierung abfragen
            this.myQuestions = this.questions.filter((q)=>{
                const key = q.propertyInfo.key.value;
                if(this.crew==='inStyle'){
                    if(key === 'basis.einverstaendnis2013'
                    || key === 'byl.agb.okt17') {
                        return false;
                    }
                    return true;
                }
                //BYL
                if(key === 'basis.adresse.number' 
                  || key === 'basis.adresse.street'
                  || key === 'basis.adresse.zip'
                  || key === 'basis.adresse.city'
                  || key === 'basis.adresse.country'
                  || key === 'crew.inStyle.einverstaendnis2023'){
                    return false;
                }
                return true;
            });
        },
        mixins: [ helper ],
        methods: {
        	getSelectChoicesSuccess: function(data) {
                this.$root.$data.selectChoices = data;
                this.selectChoicesLoaded = true;
            },
            updateAnswer: function(data, index) {
            	this.myQuestions[index].answer.value = data;
            	this.checkVisibilities();
            },
            addQuestion: function(element, key, ref) {
            	if(ref._props.question.propertyInfo.type.kind == 'CHOICE' || ref._props.question.propertyInfo.type.kind == 'SCALE') {
            		this.frage[key] = new Radio(element, ref);
            	}else if(ref._props.question.propertyInfo.type.kind == 'COUNTRY') {
            		this.frage[key] = new Select(element, ref);
            	}else if(ref._props.question.propertyInfo.type.kind == 'MULTICHOICE') {
                    this.frage[key] = new Check(element, ref);
            	}else {
            	    this.frage[key] = new QuestionElement(element, ref);
            	}
            	if(ref._props.index == this.myQuestions.length - 1) {
            		this.checkVisibilities();
            	}
            },
            checkVisibilities: function() {
            	var frage = this.frage;
            	var self = this;
            	this.myQuestions.forEach(function(item) {
            		if(item.dependenceExpression != null && item.dependenceExpression.length > 0) {
            			if(self.hideSocialMediaQuestion(item)) {
            				frage[item.questionKey].ref.hide();
                            item.answer.visible = false;
            			}else {
	            			if(eval(item.dependenceExpression)) {
	            			    frage[item.questionKey].ref.show();
	            			    item.answer.visible = true;
	            			}else {
	            				frage[item.questionKey].ref.hide();
	            				item.answer.visible = false;
	            			}
            			}
            		}
            	});
            },
            onValidate: function() {
            	if(this.$refs.questionEntry) {
                    if(this.$refs.questionEntry.constructor === Array) {
                    	var hasError = false;
                        this.$refs.questionEntry.forEach(function(item) {
                            if(item.onValidate()) {
                            	hasError = true;
                            }
                        });
                        return hasError;
                    }else {
                        return this.$refs.questionEntry.onValidate();
                    }
                }
            },
            getSocialNetworksSuccess: function(data) {
                this.socialNetworks = data;
                this.socialNetworksLoaded = true;
            },
            getSocialNetworks: function() {
                jQuery.ajax ({
                    url: '/profile/socialNetworks',
                    type: 'GET',
                    contentType: "application/json; charset=utf-8",
                    success: this.getSocialNetworksSuccess,
                    error: function() {console.log("could not load social networks")}
                });
            },
            hideSocialMediaQuestion: function(question) {
                //console.log("hideSocialMediaQuestion");
                var result = false;
                if(this.socialNetworks) {
                   if(question.propertyInfo.key.value === 'basis.twitter.follower' || question.propertyInfo.key.value === 'basis.twitter.freunde') {
                       this.socialNetworks.forEach(function(entry) {
                           if(entry.type == "TWITTER") {
                               result = true;
                               return;
                           }
                       });
                   }else if(question.propertyInfo.key.value === 'basis.instagram.follower' || question.propertyInfo.key.value === 'basis.instagram.freunde') {
                       this.socialNetworks.forEach(function(entry) {
                           if(entry.type == "INSTAGRAM") {
                               result = true;
                               return;
                           }
                       });
                   }
                }
                return result;
            }
        },
        components: { QuestionListEntry }
	}
</script>


// WEBPACK FOOTER //
// QuestionList.vue?789efa82